import React, { type JSX } from 'react';

import Box from '../Box';

import { FlexCommonProps } from './Flex.common';

export type Props = React.ComponentProps<typeof Box> & FlexCommonProps;

/** A Box that lays its children out in a row or a column. */
function Flex({ htmlRef, ref, ...props }: Props): JSX.Element {
  // React 19: pull `ref` out of props so a styled(Flex)-injected ref can't clobber htmlRef.
  return <Box display="flex" {...props} ref={htmlRef ?? ref} />;
}

export default Flex;
